var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTestNext = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "test_next_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".test_next_svg__cls-1{fill:#1f61d9}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "test_next_svg__cls-1",
    d: "M45.84 48.05H20.16c-1.24 0-2.21-1.3-2.21-2.95V20.9c0-1.65 1-2.95 2.21-2.95h25.68c1.24 0 2.21 1.3 2.21 2.95v24.2c0 1.65-.97 2.95-2.21 2.95zM20.16 20a2.65 2.65 0 00-.21.95V45.1a1.33 1.33 0 00.31 1h25.58a2.58 2.58 0 00.21-.95V20.9a1.46 1.46 0 00-.28-.95zm25.68 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "test_next_svg__cls-1",
    d: "M41.19 34H24.81a1 1 0 010-2h16.38a1 1 0 010 2zM41.19 27.6H24.81a1 1 0 110-2h16.38a1 1 0 010 2zM34.27 40.4h-9.46a1 1 0 110-2h9.46a1 1 0 010 2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTestNext);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/test_next.5df802827ab31c2a599848164f68d96e.svg";